<template>
  <div>
    <div :class="{ 'border_bottom': show }" class="commentsButton">
      <div class="iconWithNum" @click="toggleModal()">
        <img class="icon" src="/assets/img/common/chat.svg">
        <div class="num">{{ comments.length }}</div>
      </div>
    </div>
    <div class="form community" v-if="show">
      <div class="bg" @click="closeModal"></div>
      <div class="box">
        <div class="contents_wrapper">
          <h3>コメント</h3>
          <div class="comments_wrapper">
            <ul>
              <li v-for="comment in comments" class="comments_list">
                <div class="iconWithMessage sp">
                  <div class="icon">
                    <img :src="src(comment.user.image_url)">
                  </div>
                  <div>
                    <div class="name">{{ comment.user.name }}</div>
                    <div class="messageWrap">
                      <p class="message">{{ comment.content }}</p>
                      <div class="date">{{ comment.created_at }}</div>
                    </div>
                  </div>
                  <div class="reviews_wrap">
                    <post-edit v-if="userId === comment.user_id" type="community" :community="comment"></post-edit>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import vClickOutside from 'click-outside-vue3'

export default {
  props: {
    community: Object,
    comments: Array,
    imagePath: String,
    userId: Number
  },
  data() {
    return {
      show: false,
      errors: {}
    }
  },
  mounted() {},
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    toggleModal() {
      if (this.show === true) {
        this.closeModal()
      } else {
        this.showModal()
      }
    },
    showModal() {
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    src(url) {
      if (this.$_.isEmpty(url)) {
        return '/img/aloco_img_2.svg'
      } else {
        return this.imagePath + url
      }
    }
  },
  watch: {
    show(val) {
      if (!val) return
    }
  }
}
</script>

<style lang="scss" scoped>
.mypage.communities {
  .reviews_list {
    .form.community {
      display: block;

      .comments_list {
        position: relative;

        @media screen and (max-width: 768px) {
          margin-bottom: 30px;
        }
      }

      .reviews_wrap {
        position: absolute;

        @media screen and (min-width: 769px) {
          right: 24px;
          top: 32px;
        }

        @media screen and (max-width: 768px) {
          right: 0;
          top: 0;
        }
      }

      .comments_wrapper {
        >ul {
          @media screen and (max-width: 768px) {
            padding: 25px;

            li {
              width: 100%;

              .date {
                margin-top: 16px;
                color: #848484;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
